import React,{Component} from 'react';
import {Toast} from '@react/react-spectrum/Toast';
import i18n from "../../i18n";

class NoRecords extends Component{
    render(){
        return(
            <div data-am-id="toastMessage" id="toast-message">
                <Toast variant="warning">
                    {i18n.t(this.props.message,{approvalId:this.props.approvalId})}
                </Toast>
            </div>

        )
    }
}

export default NoRecords;
